import { render, staticRenderFns } from "./QueryTemplateSelectModal.vue?vue&type=template&id=65f65e6f&"
import script from "./QueryTemplateSelectModal.vue?vue&type=script&lang=ts&setup=true&"
export * from "./QueryTemplateSelectModal.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports